<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :show-close="true"
      :append-to-body="true"
      width="910px"
      top="10vh"
      custom-class="edit-role-container"
      @open="onOpen"
      @close="onClose"
    >
      <template #title>
        <div class="modal-title">编辑角色行动</div>
      </template>
      <EditRoleTab
        :tabList="tabList"
        :current="current"
        @change="onRoleTabChange"
        @append="showRolePicker = true"
        @remove="onRoleRemove"
      />
      <div v-if="Object.keys(copyCurrentInfo).length" class="role-content">
        <div class="role-action">
          <span class="label">角色行动：</span>
          <div
            :class="['action-item', { active: item.key === copyCurrentInfo.roleInfos.actionType }]"
            v-for="item in actionTypeList"
            :key="item.key"
            @click="handleCurrentAction(item.key)"
          >
            {{ item.label }}
          </div>
        </div>
        <div v-if="!copyCurrentInfo.backup" class="role-action">
          <span class="label">角色顺序：</span>
          <div
            :class="['action-item', { active: item === copyCurrentInfo.roleInfos.index }]"
            v-for="item in choosedRoleCount"
            :key="item"
            @click="handleCurrentIndex(item)"
          >
            {{ item }}
          </div>
        </div>
        <div class="clothing-box">
          <template v-if="current.type === 'role'">
            <div class="title">
              角色服饰：
            </div>
            <div v-if="current.skin && current.skin.length" :class="['cloth-line']">
              <div
                v-for="item in current.skin"
                :key="item.name"
                :class="['cloth-card', { active: item.name === copyCurrentInfo.roleInfos.choosedSkin }]"
                @click="handleChooseCloth(item.name)"
              >
                <div class="bottom-info">
                  {{ item.name }}
                </div>
                <div :class="['bg', getItemBg(current)]">
                  <img :src="item.icon" alt="" />
                </div>
              </div>
            </div>
            <div v-if="currentSkinIndex > -1" class="info-line">
              <div class="box left">
                <div class="header">服装潜能（多选）</div>
                <div class="left-content">
                  <div class="choose-box">
                    <el-checkbox-group
                      v-if="currentSkills.potential && currentSkills.potential.length"
                      v-model="copyCurrentInfo.skin[currentSkinIndex].potential"
                      @change="handlePotentialChange"
                    >
                      <el-checkbox
                        v-for="item in currentSkills.potential"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name"
                      >
                        <img v-if="item.icon" :src="item.icon" alt="" />
                        <span v-if="item.desc" class="des">{{ item.desc }}</span>
                        <template v-else>
                          <img v-if="item.image" :src="item.image" alt="" />
                        </template>
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
              <div class="box right">
                <div class="header">服装强化（单选）</div>
                <div class="right-content">
                  <div class="choose-line">
                    <el-radio-group
                      v-if="currentSkills.strengthen && currentSkills.strengthen.length"
                      v-model="copyCurrentInfo.skin[currentSkinIndex].strengthen"
                      @change="handleStrengthenChange"
                    >
                      <el-radio v-for="item in currentSkills.strengthen" :key="item.name" :label="item.name">
                        {{ item.name }}
                      </el-radio>
                    </el-radio-group>
                  </div>
                  <div class="info-box">
                    <div class="range">
                      <span class="header">
                        范围
                      </span>
                      <div class="inner-box">
                        <img
                          v-if="currentPotentialImage || currentStrengthen"
                          class="img"
                          :src="currentPotentialImage || currentStrengthen.image"
                        />
                      </div>
                    </div>
                    <div class="info-content">
                      <div class="title">
                        <span>SP：{{ calcData.sp }}</span>
                        <span style="margin-left: 20px;">CD：{{ calcData.cd }}</span>
                      </div>
                      <div class="des">
                        {{ currentStrengthen && currentStrengthen.desc }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="pet-container">
              <div class="pet-card">
                <div class="header">{{ current.name }}</div>
                <div class="inner-box">
                  <img v-if="current.icon" class="skill-img" :src="current.icon" alt="" />
                </div>
              </div>
              <div class="pet-card">
                <div class="header">范围</div>
                <div class="inner-box">
                  <img v-if="current.skill_image" class="range-img" :src="current.skill_image" alt="" />
                </div>
              </div>
              <div class="skill-box">
                <p class="skill-name">{{ current.skill_name }}</p>
                <p class="skill-des">{{ current.skill_desc }}</p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </el-dialog>
    <RolePicker v-model="showRolePicker" :roleList="roleList" @pickRole="onPickRole" />
  </div>
</template>
<script>
import { createUniqueKey, v4 } from "@/plugins/util";

import RolePicker from "./rolePicker.vue";
import EditRoleTab from "./editRoleTab.vue";

export default {
  components: { RolePicker, EditRoleTab },
  props: {
    choosedRoleCount: {
      type: Number,
      default: 0
    },
    roleList: { type: Array, default: () => [] },
    initRoleData: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      tabList: [],
      current: {},
      showRolePicker: false,
      visible: false,
      actionTypeList: [
        {
          key: "skills",
          label: "施放技能"
        },
        {
          key: "damage",
          label: "攻击"
        },
        {
          key: "repel",
          label: "击退"
        },
        {
          key: "dead",
          label: "无法战斗"
        }
      ],
      copyCurrentInfo: {}
    };
  },
  computed: {
    // 当前选中皮肤
    currentSkin() {
      const result =
        this.copyCurrentInfo.skin &&
        this.copyCurrentInfo.skin.find(item => item.name === this.copyCurrentInfo.roleInfos.choosedSkin);
      Object.assign(this.copyCurrentInfo, { currentSkin: result });
      return result;
    },
    // 当前选中皮肤的index
    currentSkinIndex() {
      const index =
        this.copyCurrentInfo.skin &&
        this.copyCurrentInfo.skin.findIndex(item => item.name === this.copyCurrentInfo.roleInfos.choosedSkin);
      Object.assign(this.copyCurrentInfo, { currentSkinIndex: index });
      return index;
    },
    // 当前选中皮肤的技能
    currentSkills() {
      let result = {
        potential: [],
        strengthen: []
      };
      if (this.currentSkin) {
        result = this.currentSkin.skills;
      }
      Object.assign(this.copyCurrentInfo, { currentSkills: result });
      return result;
    },
    // 当前强化
    currentStrengthen() {
      const choosedStrengthen =
        this.copyCurrentInfo.skin && this.copyCurrentInfo.skin[this.currentSkinIndex].strengthen;
      const currentStrengthen =
        this.currentSkills &&
        this.currentSkills.strengthen &&
        this.currentSkills.strengthen.find(item => item.name === choosedStrengthen);
      Object.assign(this.copyCurrentInfo, { currentStrengthen: currentStrengthen });
      return currentStrengthen;
    },
    // 当前潜能
    currentPotential() {
      const choosedPotential =
        (this.copyCurrentInfo.skin && this.copyCurrentInfo.skin[this.currentSkinIndex].potential) || [];
      // 当前选中的潜力
      const currentPotential = this.currentSkills.potential.filter(item => choosedPotential.includes(item.name));
      Object.assign(this.copyCurrentInfo, { currentPotential: currentPotential });
      return currentPotential;
    },
    // 潜能是否对应有范围图
    currentPotentialImage() {
      const findItem = this.currentPotential && this.currentPotential.find(item => !item.desc && item.image);
      const result = findItem && findItem.image;
      Object.assign(this.copyCurrentInfo, { currentPotentialImage: result });
      return result;
    },
    // 计算选中的潜能和强化的sp和cd
    calcData() {
      const actionType = this.copyCurrentInfo.roleInfos.actionType;
      const potential = this.currentPotential;
      const currStren = this.currentStrengthen;
      const result = {
        sp: 0,
        cd: 0
      };
      // 只有技能状态才计算sp和cd
      if (actionType === "skills") {
        potential.forEach(item => {
          result.sp += Number.isNaN(Number(item.sp)) ? 0 : Number(item.sp);
          result.cd += Number.isNaN(Number(item.cd)) ? 0 : Number(item.cd);
        });
        if (currStren) {
          result.sp += Number.isNaN(Number(currStren.sp)) ? 0 : Number(currStren.sp);
          result.cd += Number.isNaN(Number(currStren.cd)) ? 0 : Number(currStren.cd);
        }
      }
      Object.assign(this.copyCurrentInfo, { calcData: result });
      return result;
    }
  },
  methods: {
    initRoleInfos() {
      const object = JSON.parse(JSON.stringify(this.current));
      object.roleInfos.index = this.current.index || 0;
      if (this.current.type === "role") {
        object.roleInfos.actionType = this.current.actionType;
        if (this.current.currentSkin) {
          object.roleInfos.choosedSkin = this.current.currentSkin && this.current.currentSkin.name;
          const skinIndex = this.current.skin.findIndex(item => item.name === object.roleInfos.choosedSkin);
          if (this.current.currentPotential) {
            this.$set(
              object.skin[skinIndex],
              "potential",
              this.current.currentPotential.map(item => item.name)
            );
          } else {
            this.$set(object.skin[skinIndex], "potential", []);
          }
          if (this.current.currentStrengthen) {
            this.$set(object.skin[skinIndex], "strengthen", this.current.currentStrengthen.name);
          } else {
            this.$set(object.skin[skinIndex], "strengthen", "");
          }
        } else {
          const firstSkin = this.current.skin && this.current.skin[0];
          object.roleInfos.choosedSkin = firstSkin && firstSkin.name;
          // 设置默认潜力和强化
          this.$set(object.skin[0], "potential", []);
          this.$set(object.skin[0], "strengthen", "");
        }
      } else {
        object.roleInfos.actionType = this.current.actionType;
      }
      this.copyCurrentInfo = object;
    },
    // 获取背景
    getItemBg(data) {
      if (data.attr === "火") {
        return "red";
      } else if (data.attr === "光") {
        return "yellow";
      } else if (data.attr === "水") {
        return "blue";
      } else if (data.attr === "暗") {
        return "purple";
      } else if (data.attr === "风") {
        return "green";
      }
      return "";
    },
    onOpen() {
      const object = JSON.parse(JSON.stringify(this.initRoleData));
      if (!object.roleInfos) {
        object.roleInfos = {
          index: 0,
          actionType: "skills",
          choosedSkin: "",
          sp: 0,
          cd: 0
        };
      }
      let backup1 = object.backup1;
      let backup2 = object.backup2;

      this.current = object;
      this.initRoleInfos();
      this.tabList = [this.copyCurrentInfo, backup1, backup2].filter(Boolean);
    },
    onClose() {
      // 判断是否选择了 相同角色 && 相同皮肤
      const set = this.tabList.reduce((set, next) => {
        set.add(`${next.id}_${next.currentSkinIndex}`);
        return set;
      }, new Set());
      if (set.size < this.tabList.length) {
        this.$message.warning("不能选择相同角色相同皮肤");
        this.visible = true;
        return;
      }
      const setObject = index => {
        const object = this.tabList[index];
        const obj = {
          ...object,
          index: object.roleInfos.index,
          actionType: object.roleInfos.actionType,
          sp: object.roleInfos.sp,
          cd: object.roleInfos.cd
        };
        if (object.type === "role") {
          obj.currentSkin = object.currentSkin;
          obj.currentPotential = object.currentPotential;
          obj.currentStrengthen = object.currentStrengthen;
          obj.currentPotentialImage = object.currentPotentialImage;
          obj.cover_url = object.currentSkin.icon;
        }
        return obj;
      };
      const object = {
        ...setObject(0)
      };
      if (this.tabList[1]) {
        object.backup1 = setObject(1);
      }
      if (this.tabList[2]) {
        object.backup2 = setObject(2);
      }
      console.log("角色编辑 close", JSON.parse(JSON.stringify(object)));
      this.$emit("updateRole", object);
    },
    handleCurrentAction(key) {
      this.copyCurrentInfo.roleInfos.actionType = key;
    },
    handleCurrentIndex(index) {
      this.copyCurrentInfo.roleInfos.index = index;
    },
    // 强化切换
    handleStrengthenChange() {
      if (this.copyCurrentInfo.skin[this.currentSkinIndex].strengthen === "满破满潜力") {
        const potential = this.currentSkills.potential.map(item => item.name);
        this.$set(this.copyCurrentInfo.skin[this.currentSkinIndex], "potential", potential);
      }
    },
    // 潜力切换
    handlePotentialChange() {
      if (
        this.copyCurrentInfo.skin[this.currentSkinIndex].potential.length < this.currentSkills.potential.length &&
        this.copyCurrentInfo.skin[this.currentSkinIndex].strengthen === "满破满潜力"
      ) {
        this.$set(
          this.copyCurrentInfo.skin[this.currentSkinIndex],
          "strengthen",
          this.currentSkills.strengthen[0].name
        );
      }
    },
    // 切换服饰
    handleChooseCloth(key) {
      this.copyCurrentInfo.roleInfos.choosedSkin = key;
      const findSkin = this.copyCurrentInfo.skin.find(item => item.name === key);
      if (findSkin) {
        const skills = findSkin.skills;
        if (skills) {
          if (!findSkin.potential && skills.potential && skills.potential.length) {
            this.$set(this.copyCurrentInfo.skin[this.currentSkinIndex], "potential", []);
          }
          if (!findSkin.strengthen && skills.strengthen && skills.strengthen.length) {
            this.$set(this.copyCurrentInfo.skin[this.currentSkinIndex], "strengthen", "");
          }
        }
      }
    },
    onPickRole(role) {
      const currentSkin = role.skin[0];
      const currentPotential = null;
      const currentStrengthen = null;
      let sp = 0;
      let cd = 0;
      if (currentPotential) {
        sp += Number.isNaN(Number(currentPotential.sp)) ? 0 : Number(currentPotential.sp);
        cd += Number.isNaN(Number(currentPotential.cd)) ? 0 : Number(currentPotential.cd);
      }
      if (currentStrengthen) {
        sp += Number.isNaN(Number(currentStrengthen.sp)) ? 0 : Number(currentStrengthen.sp);
        cd += Number.isNaN(Number(currentStrengthen.cd)) ? 0 : Number(currentStrengthen.cd);
      }
      const object = {
        ...role,
        sp,
        cd,
        actionType: "skills",
        currentSkin,
        currentPotential,
        currentStrengthen,
        cover_url: role.icon_1,
        uniqueKey: createUniqueKey(),
        /** 替补标识 */
        backup: true,
        /** 因为可能选择相同角色，所以增加唯一key用于区分 */
        v4: v4()
      };
      object.roleInfos = {
        index: 0,
        actionType: "skills",
        choosedSkin: "",
        sp: 0,
        cd: 0
      };
      this.current = object;
      this.initRoleInfos();
      this.tabList.push(this.copyCurrentInfo);
    },
    onRoleTabChange(role) {
      this.current = role;
      this.copyCurrentInfo = role;
    },
    onRoleRemove(role) {
      const index = this.tabList.findIndex(({ id }) => id === role.id);
      if (index > -1) {
        this.tabList.splice(index, 1);
        if (role.id === this.copyCurrentInfo.id) {
          this.onRoleTabChange(this.tabList[0]);
        }
      }
    }
  }
};
</script>

<style lang="less">
@import "~@/views/wiki/battle/components/common.less";

.edit-role-container {
  background: linear-gradient(155deg, #262f3a 0%, #31415e 100%);
  .el-dialog__header {
    display: flex;
    align-items: center;
    height: 57px;
    padding: 0 20px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    .el-dialog__headerbtn {
      i {
        color: #fff;
      }
    }
  }
  .el-dialog__body {
    padding: 0 12px 12px;
    .role-content {
      border-radius: 8px;
      background: rgba(0, 0, 0, 0.4);
      .role-action {
        display: flex;
        align-items: center;
        height: 78px;
        padding: 0 20px;
        box-sizing: border-box;

        .label {
          margin-right: 8px;
          color: #fff;
          font-size: 14px;
        }
        .action-item {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 84px;
          height: 30px;
          margin-right: 16px;
          border-radius: 4px;
          background-color: transparent;
          border: 1px solid rgba(255, 255, 255, 0.12);
          color: #999999;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s;
          &:last-child {
            margin-right: 0;
          }
          &.active {
            background-color: #3b4655;
            border-color: #3b4655;
            color: #fff;
          }
        }
      }
      .clothing-box {
        padding: 18px 0;
        margin: 0 20px;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        .title {
          margin-bottom: 12px;
          color: #fff;
          font-size: 14px;
        }
        .cloth-line {
          display: flex;
          align-items: center;
          margin-bottom: 22px;
          .cloth-card {
            position: relative;
            width: 102px;
            height: 102px;
            margin-right: 8px;
            transition: all 0.3s;
            // border-radius: 4px;
            border: 2px solid #616a78;
            cursor: pointer;
            box-sizing: border-box;
            overflow: hidden;
            transition: all 0.3s;
            .bottom-info {
              position: absolute;
              display: flex;
              justify-content: center;
              align-items: center;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 24px;
              // background-color: #665f5d;
              background-color: rgba(0, 0, 0, 0.6);
              color: #fff;
              font-size: 12px;
            }
            &:last-child {
              margin-right: 0;
            }
            &.active {
              border: 2px solid #5889d4;
            }
            .bg {
              width: 100%;
              height: 100%;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }
        }
        .info-line {
          display: flex;
          .box {
            &.left {
              display: flex;
              flex-direction: column;
              width: 345px;
              flex: 0 0 auto;
              margin-right: 12px;
              .left-content {
                display: flex;
                flex: 1;
                padding: 6px 18px 18px;
                background-color: #232b39;
                border-radius: 0 0 8px 8px;
                .choose-box {
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  .el-checkbox-group {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    .el-checkbox {
                      display: flex;
                      align-items: center;
                      width: 100%;
                      height: 52px;
                      margin: 0;
                      overflow: hidden;
                      &:last-child {
                        .el-checkbox__label {
                          border-bottom: none;
                        }
                      }
                      &.is-checked {
                        .el-checkbox__input {
                          .el-checkbox__inner {
                            background-color: #5889d4;
                            border-color: #5889d4;
                          }
                        }
                      }
                      .el-checkbox__input {
                        .el-checkbox__inner {
                          border-radius: 50%;
                          border-color: #5889d4;
                          background-color: rgba(88, 137, 212, 0.15);
                        }
                      }
                      .el-checkbox__label {
                        display: flex;
                        align-items: center;
                        flex: 1;
                        height: 100%;
                        line-height: 52px;
                        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                        overflow: hidden;
                        img {
                          flex: 0 0 auto;
                          margin-right: 10px;
                          width: 28px;
                          height: 28px;
                          border-radius: 4px;
                          object-fit: cover;
                        }
                        .des {
                          flex: 1;
                          color: #ccc;
                          font-size: 12px;
                          white-space: normal;
                          line-height: 16px;
                          // overflow: hidden;
                          // text-overflow: ellipsis;
                          // white-space: nowrap;
                        }
                      }
                    }
                  }
                }
              }
            }
            &.right {
              display: flex;
              flex-direction: column;
              flex: 1;
              .right-content {
                padding: 0 16px 14px;
                background-color: #232b39;
                border-radius: 0 0 8px 8px;
                flex: 1;
                .choose-line {
                  display: flex;
                  align-items: center;
                  height: 52px;
                  border-bottom: 1px solid rgba(216, 206, 199, 0.42);
                  .el-radio-group {
                    .el-radio {
                      margin-right: 25px;
                      &:last-child {
                        margin-right: 0;
                      }
                      &.is-checked {
                        .el-radio__input {
                          .el-radio__inner {
                            background-color: #5889d4;
                            border-color: #5889d4;
                          }
                        }
                        .el-radio__label {
                          color: #fff;
                        }
                      }
                      .el-radio__input {
                        .el-radio__inner {
                          background-color: rgba(88, 137, 212, 0.14);
                          border-color: #5889d4;
                        }
                      }
                      .el-radio__label {
                        padding-left: 0;
                        color: #999;
                        font-size: 13px;
                      }
                    }
                  }
                }
                .info-box {
                  display: flex;
                  padding: 15px 0;
                  .range {
                    text-align: center;
                    flex: 0 0 auto;
                    margin-right: 20px;
                    width: 89px;
                    height: 107px;
                    border-radius: 4px;
                    overflow: hidden;
                    .header {
                      display: flex;
                      align-items: center;
                      height: 30px;
                      color: #fff;
                      font-size: 14px;
                      background-color: #3a4656;
                    }
                    .inner-box {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      height: 77px;
                      background-color: rgba(255, 255, 255, 0.04);
                      .img {
                        width: 36px;
                        height: 36px;
                        object-fit: cover;
                      }
                    }
                  }
                  .info-content {
                    .title {
                      margin-bottom: 6px;
                      color: #fff;
                      font-size: 14px;
                      line-height: 21px;
                    }
                    .des {
                      color: #ccc;
                      font-size: 12px;
                      line-height: 14px;
                    }
                  }
                }
              }
            }
            .header {
              flex: 0 0 auto;
              display: flex;
              align-items: center;
              padding-left: 15px;
              height: 36px;
              color: #fff;
              font-size: 14px;
              font-weight: bold;
              background-color: #3a4656;
              border-radius: 8px 8px 0 0;
            }
          }
        }
        .pet-container {
          display: flex;
          width: 100%;
          .pet-card {
            flex: 0 0 auto;
            margin-right: 14px;
            width: 89px;
            height: 107px;
            border-radius: 4px;
            overflow: hidden;
            .header {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 30px;
              color: #fff;
              font-size: 14px;
              background-color: #3a4656;
            }
            .inner-box {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 77px;
              background-color: rgba(255, 255, 255, 0.04);
              .skill-img {
                width: 70px;
                height: 70px;
                object-fit: cover;
              }
              .range-img {
                width: 36px;
                height: 36px;
                object-fit: cover;
              }
            }
          }
          .skill-box {
            flex: 1;
            .skill-name {
              margin-bottom: 8px;
              color: #fff;
              font-weight: 500;
              font-size: 14px;
              line-height: 21px;
            }
            .skill-des {
              color: #ccc;
              font-size: 12px;
              line-height: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
